// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"718":"3af386a9","749":"6e54c0e6","945":"69b92bdb"}[chunkId] + ".chunk.css";
};